import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { translate } from 'core/utils';
import _ from 'lodash';

function FulfillmentOrderErrorLogListTemplate({ modalParams }) {
	const { errorsList, orderId, hasErrors } = modalParams.data;
	return (
		<section>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">
					{hasErrors ? (
						<i className="type--color--error fa fa-times-circle spc--right--sml" />
					) : (
						<i className="type--color--success fa fa-check-circle spc--right--sml" />
					)}
					{translate(['FULFILLMENTORDERVIEW.ERRORLOG.MODALTITLE', { id: orderId }])}
				</h3>
			</div>
			<div className="ReactModal__body">
				{!hasErrors && (
					<div className="pickingbatch-info__entry">
						<ul className="pickingbatch-info__errors pickingbatch-info__list_no_bulletpoints">
							<li className="pickingbatch-info__success type--color--success pickingbatch-info__list_element">
								<i className="type--color--success fa fa-check-circle spc--right--nano" />
								{translate('Fulfillment order has no errors.')}
							</li>
						</ul>
					</div>
				)}
				{errorsList.length > 0 &&
					_.map(errorsList, (item, index) => {
						return (
							<div key={index} className="message__section">
								<div key={index} className="pickingbatch-info__entry">
									<h4 className="pickingbatch-info__date">{new Date(item.timeStamp).toLocaleString()}</h4>
									<ul className="pickingbatch-info__errors pickingbatch-info__list_no_bulletpoints">
										{item.failureNotification && item.failureNotification.length > 0 && (
											<li className="pickingbatch-info__error pickingbatch-info__list_element">
												<i className="type--color--error fa fa-times-circle spc--right--nano" />{' '}
												{item.failureNotification}
											</li>
										)}
										{item.notification && item.notification.length > 0 && (
											<li className="pickingbatch-info__warning pickingbatch-info__list_element">
												<i className="type--color--warning-light fa fa-exclamation-circle spc--right--nano" />{' '}
												{item.notification}
											</li>
										)}
									</ul>
								</div>
							</div>
						);
					})}
			</div>
		</section>
	);
}

export default defaultTemplate(FulfillmentOrderErrorLogListTemplate);
